import Vue from 'vue';
import store from 'store';
import { decode } from 'utils/general';
import inViewport from 'in-viewport';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import { listProductsEventData } from 'lib/tracking';
import datalayer from 'lib/datalayer';
import {Navigation, Keyboard, A11y} from "swiper/modules";

export default (el) =>
  new Vue({
    el,
    store,
    name: 'Get The Look Split',
    data: {
      swiperOptions: {
        slidesPerView: 1.3,
        spaceBetween: 10,
        a11y: true,
        keyboard: true,
        breakpoints: {
          768: {
            slidesPerView: 5
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        modules: [Navigation, A11y, Keyboard]
      },
      slideValue: '50',
    },
    mounted() {
      inViewport(this.$el, () => {
        this.trackView();
      });
    },
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
      'product-card': () => import('../product-card/product-card.vue'),
      'vue-swiper':  () => import('../vue-swiper/vue-swiper.vue'),
    },
    computed: {
      productsDecoded() {
        const productsData =  JSON.parse(decode(this.$el.dataset.productsList));
        return productsData.map((p, index) => ({...p, index: index}));
      },
    },
    methods: {
      async trackView() {
        const { products, hasBundleBuilder } = await listProductsEventData(
          this.productsDecoded,
          {
            origin: document.body.dataset.origin,
            originProduct: document.body.dataset.originProduct,
          },
        );

        let eventData = {
          ecommerce: {
            item_list_id: 'get-the-look-split',
            item_list_name:
              this.$el.dataset.heading || 'Get the look split screen',
            items: products,
          },
        };
        if (hasBundleBuilder) {
          eventData = {
            ...eventData,
            site_section: window.__GLOBAL__.siteSection,
            component_name: 'get-the-look-split',
            bundle_type: 'bundle builder',
          }
        }
        datalayer.dataLayerPush('view_item_list', eventData);
      },
      next() {
        this.$refs.carousel.$swiper.slideNext();
      },
      previous() {
        this.$refs.carousel.$swiper.slidePrev();
      },
    },
  });
